// extracted by mini-css-extract-plugin
export default {"root":"styles_root__GZoZz","primary":"styles_primary__QFiwg","transparent":"styles_transparent__xbXI1","red":"styles_red__ocN1E"};